export const productionConfig = {
    depService: `${process.env.VUE_APP_DEP_SERVICE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    campaignHubAuthHeader: `${process.env.VUE_APP_CAMPAIGN_HUB_AUTH_HEADER}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
}
export const stagingConfig = {
    depService: `${process.env.VUE_APP_DEP_SERVICE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    campaignHubAuthHeader: `${process.env.VUE_APP_CAMPAIGN_HUB_AUTH_HEADER}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
}




const environment = getEnvironment()

export const environmentConfig = getEnvObject();

function getEnvironment() {
    let base_url = window.location.origin;
    if (base_url.includes('staging')) return 'staging'
    if (base_url.includes('localhost')) return 'production'
    else return 'production'
}

function getEnvObject() {
    if (environment === 'staging') return productionConfig
    if (environment === 'development') return productionConfig
    if (environment === 'production') return productionConfig
}
